import React from "react";
import DataTable from "react-data-table-component";
import Select from "react-select";
import ReactPaginate from "react-paginate";
import "./PengajuanMonitoring.css";

export default function PengajuanMonitoring({
  rows = [], columns, pending, error, page, pageCount, pageSize, pageSizeOptions,
  search, onSearch, status, statusOptions, onStatus, appliedFilters,
  onApply, onReset, onRefresh, onPageChange, onPageSizeChange,
}) {
  const summary = [
    { label: "Pengajuan ditampilkan", value: rows.length, icon: "folder-open", tone: "blue" },
    { label: "Sedang diproses", value: rows.filter((row) => row.statusPengajuan === "Diproses").length, icon: "clock", tone: "amber" },
    { label: "Perlu perhatian", value: rows.filter((row) => row.statusPengajuan === "Revisi" || row.statusPengajuan?.includes("Gagal Terkirim")).length, icon: "exclamation-circle", tone: "red" },
    { label: "Disetujui", value: rows.filter((row) => row.statusPengajuan === "Disetujui").length, icon: "check-circle", tone: "green" },
  ];
  const hasFilters = Boolean(appliedFilters.status || appliedFilters.search);
  const firstRow = rows.length ? page * pageSize + 1 : 0;
  const customStyles = {
    table: {
      style: { minWidth: rows.length ? `${columns.reduce((total, column) => total + parseInt(column.width || column.minWidth, 10), 0)}px` : "100%" },
    },
    head: { style: { zIndex: 5 } },
    headRow: { style: { minHeight: "56px" } },
    headCells: { style: { color: "#ffffff", fontWeight: 700, fontSize: "12px", padding: "12px 16px" } },
    rows: { style: { minHeight: "76px" } },
    cells: { style: { color: "#334155", fontSize: "13px", padding: "14px 16px", lineHeight: "1.6" } },
  };
  const statusColumn = columns.find((column) => column.id === "status");
  const referenceColumn = columns.find((column) => column.id === "referensi");

  return (
    <section className="pengajuan-monitor" aria-label="Monitoring pengajuan konsumtif">
      <header className="pengajuan-hero">
        <div>
          <span className="pengajuan-eyebrow">MONITORING KREDIT</span>
          <h1>Pengajuan konsumtif</h1>
          <p>Pantau perkembangan pengajuan dan tindak lanjuti kebutuhan nasabah.</p>
        </div>
        <button type="button" className="pengajuan-refresh" onClick={onRefresh} disabled={pending}>
          <i className="fas fa-sync-alt" aria-hidden="true" /> Muat ulang
        </button>
      </header>

      <div className="pengajuan-summary-caption">
        <h2>Ringkasan halaman ini</h2>
        <span>Jumlah mengikuti data dan filter yang sedang ditampilkan</span>
      </div>
      <div className="pengajuan-summary-grid" aria-busy={pending}>
        {summary.map((item) => (
          <div className={`pengajuan-summary-item pengajuan-tone-${item.tone}`} key={item.label}>
            <span className="pengajuan-summary-icon"><i className={`fas fa-${item.icon}`} aria-hidden="true" /></span>
            <div><span>{item.label}</span><strong>{pending || error ? "—" : item.value}</strong></div>
          </div>
        ))}
      </div>

      <form className="pengajuan-filters" onSubmit={(event) => { event.preventDefault(); onApply(); }}>
        <div className="pengajuan-search-field">
          <label htmlFor="pengajuan-search">Cari pengajuan</label>
          <div className="pengajuan-search-input">
            <i className="fas fa-search" aria-hidden="true" />
            <input id="pengajuan-search" type="search" value={search} onChange={onSearch}
              placeholder="Referensi ID atau nama nasabah" disabled={pending} />
          </div>
        </div>
        <div className="pengajuan-status-field">
          <label htmlFor="pengajuan-status">Status pengajuan</label>
          <Select inputId="pengajuan-status" classNamePrefix="pengajuan-select" value={status}
            onChange={onStatus} options={statusOptions} placeholder="Semua status" isClearable isDisabled={pending} />
        </div>
        <div className="pengajuan-filter-actions">
          <button type="submit" className="pengajuan-primary-button" disabled={pending}>Terapkan filter</button>
          <button type="button" className="pengajuan-secondary-button" disabled={pending} onClick={onReset}>Reset</button>
        </div>
      </form>

      <div className="pengajuan-results" aria-busy={pending}>
        <div className="pengajuan-results-heading">
          <div>
            <h2>Daftar pengajuan</h2>
            <div className="pengajuan-applied-filters">
              <span>{appliedFilters.status || "Semua status"}</span>
              {appliedFilters.search && <span>Pencarian: {appliedFilters.search}</span>}
            </div>
          </div>
          <span className="pengajuan-scroll-hint"><i className="fas fa-arrows-alt-h" aria-hidden="true" /> Geser untuk melihat kolom lainnya</span>
        </div>

        {pending ? (
          <div className="pengajuan-loading" role="status">
            <span>Memuat data pengajuan…</span>
            {[0, 1, 2, 3].map((index) => <div className="pengajuan-skeleton" key={index} aria-hidden="true" />)}
          </div>
        ) : error ? (
          <div className="pengajuan-empty" role="alert">
            <i className="fas fa-exclamation-circle" aria-hidden="true" />
            <h3>Data belum tersedia</h3><p>{error}</p>
            <button type="button" className="pengajuan-primary-button" onClick={onRefresh}>Coba lagi</button>
          </div>
        ) : !rows.length ? (
          <div className="pengajuan-empty" role="status">
            <i className="fas fa-search" aria-hidden="true" />
            <h3>{hasFilters ? "Pengajuan tidak ditemukan" : "Belum ada pengajuan"}</h3>
            <p>{hasFilters ? "Coba kata pencarian atau status lain untuk melihat pengajuan." : "Data pengajuan akan tampil di sini saat tersedia."}</p>
            {hasFilters && <button type="button" className="pengajuan-secondary-button" onClick={onReset}>Reset filter</button>}
          </div>
        ) : (
          <>
            <div className="pengajuan-table-frame">
              <DataTable className="pengajuan-data-table" keyField="id_pinjaman" columns={columns} data={rows}
                customStyles={customStyles} fixedHeader fixedHeaderScrollHeight="65vh" />
            </div>
            <div className="pengajuan-mobile-list" aria-label="Daftar pengajuan">
              {rows.map((row, index) => (
                <article className="pengajuan-mobile-card" key={row.id_pinjaman}>
                  <header>
                    <span className="pengajuan-row-number">{firstRow + index}</span>
                    <h3>{row.namaLengkap || "-"}</h3>
                  </header>
                  <div className="pengajuan-mobile-reference">{referenceColumn.cell(row)}</div>
                  <div className="pengajuan-mobile-status">{statusColumn.cell(row)}</div>
                  <dl>
                    {columns.filter((column) => !["no", "nasabah", "referensi", "status", "aksi"].includes(column.id)).map((column) => (
                      <div key={column.name}><dt>{column.name}</dt><dd>{column.cell ? column.cell(row) : column.selector(row, index)}</dd></div>
                    ))}
                  </dl>
                  <footer><span>Tindak lanjut</span>{row.action}</footer>
                </article>
              ))}
            </div>
          </>
        )}

        <footer className="pengajuan-table-footer">
          <div className="pengajuan-page-size">
            <label htmlFor="pengajuan-page-size">Baris per halaman</label>
            <Select inputId="pengajuan-page-size" classNamePrefix="pengajuan-select" isSearchable={false}
              value={pageSizeOptions.find((option) => option.value === pageSize)} options={pageSizeOptions}
              onChange={onPageSizeChange} isDisabled={pending} menuPlacement="auto" />
          </div>
          {!pending && !error && <span className="pengajuan-page-info">
            {rows.length ? `${firstRow}–${firstRow + rows.length - 1} · Halaman ${page + 1} dari ${Math.max(pageCount, 1)}` : "0 pengajuan"}
          </span>}
          {!pending && !error && pageCount > 0 && (
            <nav aria-label="Halaman pengajuan">
              <ReactPaginate forcePage={page} pageCount={pageCount} pageRangeDisplayed={3} marginPagesDisplayed={1}
                containerClassName="pengajuan-pagination" pageClassName="pengajuan-page-item" pageLinkClassName="pengajuan-page-link"
                previousClassName="pengajuan-page-item" previousLinkClassName="pengajuan-page-link"
                nextClassName="pengajuan-page-item" nextLinkClassName="pengajuan-page-link"
                breakClassName="pengajuan-page-item" breakLinkClassName="pengajuan-page-link"
                activeClassName="pengajuan-page-active" activeLinkClassName="pengajuan-page-current"
                disabledClassName="pengajuan-page-disabled" previousLabel="‹" nextLabel="›" breakLabel="…"
                previousAriaLabel="Halaman sebelumnya" nextAriaLabel="Halaman berikutnya"
                ariaLabelBuilder={(number) => `Halaman ${number}`} disableInitialCallback
                onPageChange={({ selected }) => onPageChange(selected)} />
            </nav>
          )}
        </footer>
      </div>
    </section>
  );
}
